// src/views/Pages/DataArchive/TransactionManager/useBankStatementPDF.ts
import { useEffect, useState } from "react";
import { getJwt } from "src/auth";

const BASE_URL = process.env.NODE_ENV === "production" ? "https://www.docuclipper.com" : "http://localhost:8080";

const PDF_VIEWER_HASH = "#page=1&pagemode=none&toolbar=1";

const useBankStatementPDF = ({
  selectedDocumentId,
}) => {
  const [pdfURL, setPdfURL] = useState<string>("");

  useEffect(() => {
    let cancelled = false;
    const jwt = getJwt();

    if (!selectedDocumentId || !jwt) {
      setPdfURL("");
      return;
    }

    (async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/v1/protected/document/${selectedDocumentId}/downloads3`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${jwt}`,
            },
          },
        );

        if (!response.ok) {
          throw new Error(`Failed to fetch presigned URL: ${response.statusText}`);
        }

        const data = await response.json();
        if (!cancelled) {
          setPdfURL(`${data.url}${PDF_VIEWER_HASH}`);
        }
      } catch (err) {
        if (!cancelled) {
          console.error("useBankStatementPDF: failed to fetch presigned URL", err);
          setPdfURL("");
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [selectedDocumentId]);

  return {
    pdfURL,
  };
};

export default useBankStatementPDF;
